export default {
  medium: 'medium',
  large: 'large',
  small: 'small',
};
